import { useState, useEffect, useRef } from "react";

// react-google-recaptcha-v3
// react-router-dom components
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
// @mui material components
// Material Kit 2 PRO React components
import MKBox from "../../components/MKBox";
import MKButton from "../../components/MKButton";

import Button from "@mui/material/Button";
import { useSelector } from "react-redux";

import constants from "../../common/constants.js";
import AppHost from "../../common/AppHost.js";
// Image
import CapsLockIdentifier from "../../components/IRAGeneralComponents/UtilComponents/CapsLockIdentifier";
import PageLayout from "../../layouts/dashboards";
import AuthenticationCardLayout from "../../layouts/AuthenticationCard/AuthenticationCardLayout";
import AuthenticationMKInput from "../../layouts/AuthenticationCard/AuthenticationMKInput";
import MDBox from "../../components/MDBox";
import { useDispatch } from "react-redux";
import api from "../../api/api.js";
import {
  updateToken,
  updateUserDetails,
  updateRolesAndRoleClaims,
  clearUser,
} from "../../redux/features/user/userSlice";
import axios from "axios";
import CustomInfoDialog from "../../components/Dialog";
import "react-toastify/dist/ReactToastify.css";

import useRecaptcha from "../../customhooks/Recaptcha/useRecaptcha.js";
import { Axios_PostRecaptchaVerification } from "../../api/axiosFunctions.js";
/**
 * @URL_PARAMS app=wSdBkpYNs0yOseHvoudDZg / ref=logout / reportid=xxx
 * @returns
 */
function Page() {
  const { handleCaptchaVerification, RecaptchaComponent, recaptchaObject } = useRecaptcha({
    enableLogging: false,
    recaptchaVerificationFn: (token) => Axios_PostRecaptchaVerification(token),
    tolerance: constants.googleRecaptcha.scoreTolerance,
  });

  // Redux
  const user = useSelector((state) => state.user);
  const userRef = useRef(null);
  useEffect(() => {
    userRef.current = user; // Update the ref whenever user changes
  }, [user]);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const appRedux = useSelector((state) => state.app);
  const [searchParams, setSearchParams] = useSearchParams();

  const [inputs, setInputs] = useState({
    user_name: constants.user_defaultUser0,
    hash:
      constants.env_ === "Dev"
        ? constants.user_defaultPass1
        : constants.user_defaultPass0,
  });
  const [viewMode, setViewMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [navigatedFromApp, setNavigatedFromApp] = useState(undefined);

  /* #region Authentication MK Inputs */
  const [isHitEnter, setIsHitEnter] = useState(false);
  const [events, setEvents] = useState(null);
  useEffect(() => {
    if (isHitEnter) {
      handleLogin();
      setIsHitEnter(false);
    }
  }, [isHitEnter]);
  const [mkErrors, setMkErrors] = useState({
    user_name: { state: false, message: "" },
    hash: { state: false, message: "" },
  });
  /* #endregion */

  /* #region CustomInfoDialog  */
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [infoDialogParams, setInfoDialogParams] = useState({
    title: "",
    messageLine1: "",
    type: "info",
    navigateToUrl: "",
  });
  const handleOpenInfoDialog = (title, msg, type, navigateToUrl) => {
    setInfoDialogParams({
      ...infoDialogParams,
      title: title,
      messageLine1: msg,
      type: type,
      navigateToUrl: navigateToUrl,
    });
    setOpenInfoDialog(true);
  };
  /* #endregion */

  /* #region  UseEffect - On Init Page*/
  useEffect(() => {
    getNavigatedFromApplication(); // not needed as requirements stated all logins should land on landing portal
    dispatch(clearUser()); // Clear all redux states/user information
  }, []);
  /* #endregion */

  /* #region  Login Functions */



  const handleLogin = async () => {

    setIsLoading(true);
    const isVerified = await handleCaptchaVerification();
    if (isVerified) {
      console.log("Captcha verified successfully!");
    } else {
      console.error("Captcha verification failed.");
      setIsLoading(false);
      return;
    }


    setViewMode(true);
    if (validateFields()) {
      var data = {
        user_name: inputs.user_name,
        password: inputs.hash,
      };
      var header = {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      };

      try {
        await axios
          .post(api.femsLogin, data, header)
          .then((res) => {
            var data = res.data;
            var accessToken = data.access_token;
            var requirePasswordChange = data.require_change_password;

            // Dispatch Token - Redux
            dispatch(updateToken(data));
            if (requirePasswordChange) {
              handleChangePassword();
            } else {
              validateToken(accessToken);
            }
          })
          .catch((err) => {
            if (constants.env_ === "Dev") {
              console.log("ERROR Login: ", err);
            }
            try {
              var errorResponse = err?.response?.data?.errors ?? [];
              if (
                (errorResponse?.error_code ?? "") ===
                constants.userAccountLockedFeasCode
              ) {
                handleOpenInfoDialog(
                  "Login failed",
                  errorResponse?.error_desc ?? "Login failed, Please try again",
                  "error"
                );
              } else if (
                (errorResponse?.error_code ?? "") ===
                constants.userAccountDisabledFeasCode
              ) {
                handleOpenInfoDialog(
                  "Login failed",
                  errorResponse?.error_desc +
                  " Please contact the administrator" ??
                  "Login failed, Please try again",
                  "error"
                );
              } else {
                handleOpenInfoDialog(
                  "Error",
                  "Login failed, Please try again",
                  "error"
                );
              }
            } catch (e) {
              handleOpenInfoDialog(
                "Error",
                "Login failed, Please try again",
                "error"
              );
            } finally {
              setIsLoading(false);
            }
          })
          .finally(() => { });
      } catch (ex) {
        setIsLoading(false);
      }
    }

    setViewMode(false);
    setIsLoading(false);
  };

  /* #endregion */

  /** Validate Token From Login & HANDLE REDIRECTION */
  const validateToken = async (
    token,
    clearUserInfoGracefullyIfNotValid = false
  ) => {
    const jwtConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    };

    // Get redirect param from URL
    const redirectUrl = searchParams.get("redirect");

    // Extract jtccase from redirect param if present
    let jtccase = null;
    if (redirectUrl && redirectUrl.includes("jtccase=")) {
      const urlParams = new URLSearchParams(redirectUrl.split("?")[1]);
      jtccase = urlParams.get("jtccase");
    }

    await axios
      .get(api.femsValidateToken, jwtConfig)
      .then(async (res) => {
        try {
          if (res.status == 200) {
            var subDomain = generateAppCodeEndpoint(navigatedFromApp);

            // Check IF user has access to ONLY ONE APP
            let accessibleApps = [];
            (res.data?.roles ?? []).forEach((element) => {
              if (!accessibleApps.includes(element.app_code)) {
                accessibleApps.push(element.app_code);
              }
            });
            let data = res.data;

            dispatch(updateUserDetails({ ...data }));
            dispatch(updateRolesAndRoleClaims(data.roles));

            // Is IRA Direct Navigation To Report
            try {
              // IRA logic (unchanged)
              if (
                accessibleApps !== undefined &&
                accessibleApps.includes(AppHost.IRA.code) &&
                subDomain &&
                subDomain.includes("reportid") &&
                navigatedFromApp === AppHost.IRA.code
              ) {
                await checkValueWithTimeout(3000);
                var targetURI = constants.domain + (subDomain ?? "home");
                if (constants.env_ === "Dev") {
                  console.log("Please go to IRA Report. " + targetURI);
                } else {
                  window.location.href = targetURI;
                }
                return;
              }
              // JMM-specific redirect logic (external project)
              else if (
                Array.isArray(accessibleApps) &&
                accessibleApps.includes(AppHost.JMM.code) &&
                jtccase // If jtccase param exists, it's a JMM deep link
              ) {
                await checkValueWithTimeout(3000);

                if (redirectUrl) {
                  setIsLoading(false);
                  console.log("Redirect URL detected:", redirectUrl);
                  // If redirectUrl is absolute, use it directly
                  if (/^https?:\/\//i.test(redirectUrl)) {
                    console.log("Redirecting to absolute URL:", redirectUrl);
                    window.location.href = redirectUrl;
                  } else {
                    // Otherwise, prepend your domain
                    const externalJmmDomain = constants.domain; // or your actual JMM domain
                    const redirectPath = redirectUrl.startsWith("/") ? redirectUrl.slice(1) : redirectUrl;
                    console.log("Redirecting to:", externalJmmDomain + redirectPath);
                    window.location.href = externalJmmDomain + redirectPath;
                  }
                } else {
                  // fallback logic if needed
                  const params = [];
                  for (const [key, value] of searchParams.entries()) {
                    if (key !== "app") {
                      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
                    }
                  }
                  const queryString = params.length > 0 ? `?${params.join("&")}` : "";
                  console.log("No redirectUrl, fallback to:", constants.domain + "jmm/app/case/info" + queryString);
                  // window.location.href = constants.domain + "jmm/app/case/info" + queryString;
                }
                return;
              }
            } catch (e) {
              console.log(e);
            } finally {
            }
            await checkValueWithTimeout(500);
            setIsLoading(false);
            console.log("Navigating to /home/");
            navigate("/home/");
            return;
          } else {
            handleOpenInfoDialog(
              "Access Validation failed",
              "Please try again or contact the system administrator",
              "error"
            );
          }
        } catch (e) { }
      })
      .catch((error) => {
        dispatch(clearUser());
        if (!clearUserInfoGracefullyIfNotValid) {
          handleOpenInfoDialog(
            "An unexpected error occured. ",
            "Please try again or contact the system administrator",
            "error"
          );
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  /** Description: function will wait 3 seconds for dispatch updates to finish.
   * If it finishes earlier, it will resolve itself. */
  async function checkValueWithTimeout(timeoutMs = 3000, intervalMs = 50) {
    const startTime = Date.now();

    while (Date.now() - startTime < timeoutMs) {
      const currentUser = userRef.current;

      if (
        currentUser.user_name !== undefined &&
        currentUser.user_name !== "" &&
        (currentUser.roleClaims ?? []).length > 0 &&
        currentUser.token !== "" &&
        currentUser.token !== undefined
      ) {
        // Condition met early, but still wait the remaining time
        // await new Promise((resolve) =>
        //   setTimeout(resolve, timeoutMs - (Date.now() - startTime))
        // );
        return; // Exit after waiting the remaining time
      }

      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }

    throw new Error(
      "Timeout exceeded while waiting for Dispatch User Information."
    );
  }

  /** Validate input fields */
  const validateFields = () => {
    if (inputs.user_name === "" && inputs.hash === "") {
      handleOpenInfoDialog(
        "Input Error",
        "Please key in all the required fields - Email & Password",
        "error"
      );
      setMkErrors({
        ...mkErrors,
        user_name: {
          state: inputs.user_name == "",
          message: "Please enter your username",
        },
        hash: {
          state: inputs.hash == "",
          message: "Please enter your password",
        },
      });
      return false;
    } else if (inputs.user_name === "" || inputs.user_name === undefined) {
      handleOpenInfoDialog(
        "Input Error",
        "Please re-enter your Email ",
        "error"
      );
      setMkErrors({
        ...mkErrors,
        user_name: {
          state: (inputs.user_name ?? "") === "",
          message: "Please enter your username",
        },
      });
      setInputs({ ...inputs, user_name: "" });
      return false;
    } else if (inputs.hash == "") {
      handleOpenInfoDialog(
        "Input Error",
        "Please key in your Password",
        "error"
      );
      setMkErrors({
        ...mkErrors,
        hash: {
          state: inputs.hash == "",
          message: "Please enter your password",
        },
      });
      return false;
    }
    return true;
  };

  const handleForgetPassword = () => {
    navigate("/forgetpassword");
  };
  const handleChangePassword = () => {
    navigate("/changepassword", {
      state: {
        email: inputs.user_name,
        isAuthenticated: false,
      },
    });
  };

  /** This function determines the endpoint to redirect to based on APP_CODE */
  const generateAppCodeEndpoint = (APP_CODE) => {
    switch (APP_CODE) {
      case AppHost.AMM.code:
        return "amm/app/dashboard/";
        break;
      case AppHost.IRA.code:
        var ira_id =
          searchParams.get("reportid") ?? searchParams.get("reportId");
        var idParam = ira_id !== undefined ? `?reportid=${ira_id}` : "";
        var endpoint =
          ira_id === undefined || ira_id === null
            ? "ira/app/incidents/view/"
            : "ira/app/incidents/report" + idParam;
        return endpoint;
        break;
      case AppHost.JMM.code:
        // Support deep link to case info if jtccase param exists
        var jmm_case = searchParams.get("jtccase");
        if (jmm_case) {
          // Collect all query params for this deep link
          const params = [];
          for (const [key, value] of searchParams.entries()) {
            if (key !== "app") { // Exclude the app param if present
              params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
          }
          const queryString = params.length > 0 ? `?${params.join("&")}` : "";
          return `jmm/app/case/info${queryString}`;
        }
        return "jmm/app/"
        break;
      case AppHost.JTA.code:
        return "jta/app/";
        break;
      default:
        break;
    }
    return undefined;
  };

  /** This function detects the Source App  */
  const getNavigatedFromApplication = () => {
    try {
      // Get ROUTED_FROM_APPLICATION?
      var tmpNavigatedFrom = "";

      //  tmpNavigatedFrom = appRedux.sourceApp;  // Read Redux state

      // if (tmpNavigatedFrom === "" || tmpNavigatedFrom === "none") {
      var params = searchParams.get("app") ?? "";

      if (params === AppHost.JMM.param) tmpNavigatedFrom = AppHost.JMM.code;
      if (params === AppHost.JTA.param) tmpNavigatedFrom = AppHost.JTA.code;
      if (params === AppHost.IRA.param) tmpNavigatedFrom = AppHost.IRA.code;
      if (params === AppHost.AMM.param) tmpNavigatedFrom = AppHost.AMM.code;
      // }

      setNavigatedFromApp(tmpNavigatedFrom);
    } catch (e) {
      // return "";
    } finally {
    }
  };

  return (
    <PageLayout>
      <AuthenticationCardLayout
        title="FEM Cloud Login"
        loading={isLoading}
        isAuthenticated={false}
      >
        <form>
          <AuthenticationMKInput
            inputType="emailx" // x added to prevent wrong autofilling
            inputName={"user_name"}
            inputLabel={"Email Address"}
            inputs={inputs}
            setInputs={setInputs}
            setEvents={setEvents}
            setIsEnter={setIsHitEnter}
            errorState={mkErrors.user_name.state}
            errorMessage={mkErrors.user_name.message}
          />
          <AuthenticationMKInput
            inputType="password"
            inputName={"hash"}
            inputLabel={"Password"}
            inputs={inputs}
            setInputs={setInputs}
            setEvents={setEvents}
            setIsEnter={setIsHitEnter}
            errorState={mkErrors.hash.state}
            errorMessage={mkErrors.hash.message}
          />
        </form>
        <CapsLockIdentifier events={events} />

        <MDBox
          mb={1}
          ml={-2}
          sx={({ breakpoints }) => ({
            [breakpoints.down("md")]: {
              minWidth: "80vw",
            },
          })}
        >
          <Button variant="text" onClick={handleForgetPassword}>
            Forget Password?
          </Button>
        </MDBox>

        <MKBox display="flex" justifyContent="center">
          <MKBox mt={5}>
            <MKButton
              onClick={handleLogin}
              type="submit"
              color="info"
              size="large"
              fullWidth
              disabled={viewMode}
            >
              Login
            </MKButton>
          </MKBox>
        </MKBox>
        <p> </p>


        {(recaptchaObject.success === true || recaptchaObject.success === false)
          && <RecaptchaComponent />}
      </AuthenticationCardLayout>

      <CustomInfoDialog
        open={openInfoDialog}
        title={infoDialogParams.title}
        messageLine1={infoDialogParams.messageLine1}
        type={infoDialogParams.type}
        setOpenDialog={setOpenInfoDialog}
        navigateToUrl={infoDialogParams.navigateToUrl}
      />
    </PageLayout>
  );
}

export default Page;
